import {retiredTrialObjects} from '../../application/current-product';
import {Toggle} from '../../ui/Mobile';
import {Disclosure} from '../../ui/Mobile';
import {PageTitle,Sheet} from '../../ui/Mobile';
import {Input, Textarea, Picker, Button} from '../../ui/Mobile';
import { LoadingPage } from '../../ui/States';
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate, useSearchParams } from "../../app/navigation";
import { useLiveQuery } from "dexie-react-hooks";
import { useService } from "../../app/context";
import { usePendingNavigation } from "../../app/usePendingNavigation";
import {
  ContentService,
  visibleContent,
} from "../../application/content-service";
import { ContentEditor } from "../../application/content-editor";
import {
  contentLabels,
  contentPath,
  contentTitle,
  blankContent,
  type ContentKind,
  type Content,
} from "../../domain/content/model";
import { prepareImage } from "../../infrastructure/attachments/prepare";
import { AttachmentImage } from "../../ui/AttachmentImage";
import {
  assertWritable,
  markSearchDirty,
} from "../../infrastructure/database/database";
import { exportText } from "../../infrastructure/platform/files";
function safeLink(value: string) {
  try {
    return ["https:", "http:"].includes(new URL(value).protocol);
  } catch {
    return false;
  }
}
function ContentSnapshot({ item }: { item: Content }) {
  return (
    <div>
      <h3>{contentTitle(item)}</h3>
      {"diaryDate" in item && <p>日记日期：{item.diaryDate}</p>}
      {"choice" in item && (
        <>
          <p>选择：{item.choice}</p>
          <p className="capture-body">理由：{item.reason}</p>
        </>
      )}
      <p className="capture-body">{item.body}</p>
      {"url" in item && (
        <>
          <p>来源链接：{item.url || "未填写"}</p>
          <p className="capture-body">摘录：{item.excerpt}</p>
          <p className="capture-body">摘要：{item.summary}</p>
        </>
      )}
      <div className="attachment-grid">
        {item.attachmentIds.map((id) => (
          <AttachmentImage key={id} id={id} />
        ))}
      </div>
    </div>
  );
}
export function ContentList({ kind }: { kind: ContentKind }) {
  const { db } = useService(),
    [params, setParams] = useSearchParams();
  const date = params.get("date") ?? "",
    tag = params.get("tag") ?? "",
    view = params.get("view") ?? "recent",
    month = params.get("month") ?? new Date().toISOString().slice(0, 7);
  const data = useLiveQuery(
    () =>
      db.transaction("r", db.tables, async () => {const hidden=await retiredTrialObjects(db);return {
        rows: (await visibleContent(db, kind)).filter(x=>kind!=='resource'||!hidden.resources.has(x.item.id)),
        hidden: (await db.settings.get("diarySummary"))?.value === "hidden",
      };}),
    [db, kind],
  );
  const all = data?.rows ?? [],
    rows = all
      .filter(
        (x) =>
          (!date || ("diaryDate" in x.item && x.item.diaryDate === date)) &&
          (!tag || x.tags.includes(tag)),
      )
      .sort(
        (a, b) =>
          ("diaryDate" in b.item
            ? b.item.diaryDate
            : b.item.updatedAt
          ).localeCompare(
            "diaryDate" in a.item ? a.item.diaryDate : a.item.updatedAt,
          ) || a.item.id.localeCompare(b.item.id),
      );
  return (
    <main className={'page content-list '+kind+'-list'+(kind==='diary'?' module-landing':'')} id="main" data-ready={!!data}>
      <div className="page-heading"><PageTitle secondary={kind!=="diary"}>{contentLabels[kind]}</PageTitle>{kind !== 'diary' && <Link className="button primary" to={`${contentPath(kind)}/new`}>新建{contentLabels[kind]}</Link>}</div>
      {kind === 'diary' && <section className="diary-compose"><div><h2>{date || '今天'}</h2><p className="meta">文字与图片，保存在本机</p></div><Link className="button primary diary-write" to={'/diaryEntries/new'+(date?'?date='+date:'')}>{date ? '在这一天写一篇' : '写今天'}</Link></section>}
      {kind==='diary'&&<div className="section-heading"><h2>最近日记</h2></div>}
      {rows.map((x) => (
        <Link
          key={x.draft?.id ?? x.item.id}
          className={"record-row "+(kind==="diary"?"diary-entry":"content-entry")}
          to={
            contentPath(kind, x.item.id) +
            (x.draft ? "/edit?draft=" + x.draft.id : "")
          }
        >
          <div>
            <strong>
              {kind === "diary" && data?.hidden ? "日记" : contentTitle(x.item)}
            </strong>
            <p>
              {"diaryDate" in x.item
                ? x.item.diaryDate
                : x.item.updatedAt.slice(0, 10)}
              {x.draft ? " · 草稿" : ""}
              {x.conflict ? " · 冲突分支" : ""}
              {x.item.archivedAt ? " · 已归档" : ""}{x.tags.length ? " · "+x.tags.join("、") : ""}
            </p>
            {!(kind === "diary" && data?.hidden) && (
              <p className="entry-excerpt">{kind === "diary" && "diaryDate" in x.item && !x.item.title ? x.item.body.slice(contentTitle(x.item).length).trim().slice(0,120) : x.item.body.slice(0,120)}</p>
            )}
          </div>
        </Link>
      ))}
      {data && !rows.length && (
        <p className="quiet-empty">
          {kind === "diary" ? "还没有日记" : "还没有记录"}

        </p>
      )}
      <Sheet className="content-tools" label="筛选" trigger={<>筛选</>}>
      {kind === "diary" && (
        <>
          <Button
            onClick={() =>
              setParams({
                view: view === "calendar" ? "recent" : "calendar",
                month,
              })
            }
          >
            {view === "calendar" ? "最近列表" : "日历"}
          </Button>
          <section className="form-section">          <label>
            日记日期
            <Input
              type="date"
              value={date}
              onChange={(e) =>
                setParams({ view, month, date: e.target.value, tag })
              }
            />
          </label>
          </section>
          {view === "calendar" && (
            <section aria-label="日记日历">
              <label>
                月份
                <Input
                  type="month"
                  value={month}
                  onChange={(e) =>
                    setParams({ view, month: e.target.value, tag })
                  }
                />
              </label>
              <div className="diary-calendar">
                {["日", "一", "二", "三", "四", "五", "六"].map((day) => (
                  <span key={day} aria-hidden="true">
                    {day}
                  </span>
                ))}
                {Array.from(
                  { length: new Date(month + "-01T00:00:00Z").getUTCDay() },
                  (_, i) => (
                    <span aria-hidden="true" key={"blank" + i} />
                  ),
                )}
                {Array.from(
                  {
                    length: new Date(
                      Number(month.slice(0, 4)),
                      Number(month.slice(5, 7)),
                      0,
                    ).getDate(),
                  },
                  (_, i) => {
                    const day = month + "-" + String(i + 1).padStart(2, "0"),
                      has = all.some(
                        (x) =>
                          "diaryDate" in x.item && x.item.diaryDate === day,
                      );
                    return (
                      <Button
                        key={day}
                        aria-label={day + (has ? " 有日记" : "")}
                        aria-pressed={day === date}
                        onClick={() =>
                          setParams({ view, month, date: day, tag })
                        }
                      >
                        {i + 1}
                        {has ? " ·" : ""}
                      </Button>
                    );
                  },
                )}
              </div>
            </section>
          )}
        </>
      )}
      <section className="form-section"><label className="tag-filter">
        标签筛选
        <Picker
          value={tag}
          onChange={(e) =>
            setParams({ view, month, date, tag: e.target.value })
          }
        >
          <option value="">全部标签</option>
          {[...new Set(all.flatMap((x) => x.tags))].map((t) => (
            <option key={t}>{t}</option>
          ))}
        </Picker>
      </label></section>
      <nav className="utility-links" aria-label={contentLabels[kind]+'入口'}>{kind !== 'diary' && <Link to="/space">空间</Link>}<Link to="/trash">回收站</Link></nav></Sheet>
    </main>
  );
}
export function ContentForm({ kind }: { kind: ContentKind }) {
  const { db } = useService(),
    { id } = useParams(),
    [params, setParams] = useSearchParams(),
    navigate = useNavigate();
  const [editor, setEditor] = useState<ContentEditor>(),
    [, render] = useState(0),
    [busy, setBusy] = useState(false),
    [message, setMessage] = useState(""),
    [preview, setPreview] = useState(false),
    [tagText, setTagText] = useState<string>();
  const done = useRef(false),
    loading = useRef(false);
  usePendingNavigation(!done.current && (busy || !!editor?.pending || !!editor?.failure));
  const source = params.get("capture");
  useEffect(() => {
    if (loading.current) return;
    loading.current = true;
    void (async () => {
      const service = new ContentService(db),
        draft = params.get("draft")
          ? await db.contentDrafts.get(params.get("draft")!)
          : undefined,
        existing = id ? await service.get(kind, id) : undefined;
      if (
        draft &&
        (draft.kind !== kind ||
          draft.deletedAt ||
          (id && draft.targetId !== id))
      )
        throw Error("草稿归属不一致");
      if (id && !existing && !draft) throw Error("记录不存在");
      if (existing?.deletedAt) throw Error("请先从回收站恢复");
      const compatible =
        !draft && existing
          ? (await visibleContent(db, kind)).find((x) => x.item.id === id)
              ?.draft
          : undefined;
      const d = draft ?? compatible;
      const capture = source
        ? await db.captures.get(source)
        : d?.sourceCaptureId
          ? await db.captures.get(d.sourceCaptureId)
          : undefined;
      if (source && (!capture || capture.deletedAt))
        throw Error("整理来源不存在");
      const value =
        d?.payload ??
        existing ??
        blankContent(
          kind,
          String((await db.settings.get("timeZone"))?.value ?? "UTC"),
        );
      if (!d && !existing) {
        if (kind === "diary" && params.get("date"))
          (value as Content & { diaryDate: string }).diaryDate =
            params.get("date")!;
        if (capture) {
          value.body = capture.body;
          value.title =
            kind === "diary" ? "" : capture.body.split("\n")[0].slice(0, 200);
          value.attachmentIds = [...capture.attachmentIds];
          if (kind === "decision" && "reason" in value)
            value.reason = capture.body;
        }
      }
      const c = new ContentEditor(
        service,
        kind,
        value,
        d?.baseRevision ?? existing?.revision ?? 0,
        capture
          ? {
              captureId: capture.id,
              revision: d?.sourceRevision ?? capture.revision,
            }
          : null,
        () => render((n) => n + 1),
        d,
      );
      setTagText(
        (await db.tags.bulkGet(value.tagIds))
          .map((t) => t?.name ?? "")
          .join(","),
      );
      setEditor(c);
    })().catch((e) => setMessage((e as Error).message));
  }, [db, id, kind, params, source]);
  useEffect(() => {
    if (
      editor?.draftRevision &&
      !busy &&
      !editor.pending &&
      !done.current &&
      params.get("draft") !== editor.draftId
    )
      setParams(
        {
          draft: editor.draftId,
          ...(editor.source ? { capture: editor.source.captureId } : {}),
        },
        { replace: true },
      );
  }, [
    editor?.draftId,
    editor?.draftRevision,
    params,
    setParams,
    editor,
    busy,
    editor?.pending,
  ]);
  async function publish(asCopy = false) {
    if (!editor) return;
    if (editor.source && !preview && !asCopy) {
      setBusy(true);
      try {
        if (!editor.draftRevision) await editor.save();
        await editor.flush();
        setPreview(true);
      } catch (e) {
        setMessage((e as Error).message);
      } finally {
        setBusy(false);
      }
      return;
    }
    setBusy(true);
    try {
      if (!editor.draftRevision) await editor.save();
      await editor.flush();
      const item = await editor.service.publish(
        editor.draftId,
        editor.draftRevision,
        crypto.randomUUID(),
        asCopy,
      );
      done.current = true;
      navigate(contentPath(kind, item.id), { replace: true });
    } catch (e) {
      setMessage((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  const comparison = useLiveQuery(
    async () =>
      editor
        ? {
            current: await new ContentService(db).get(kind, editor.value.id),
            branches: (
              await db.contentDrafts
                .where("targetId")
                .equals(editor.value.id)
                .toArray()
            ).filter((d) => !d.deletedAt),
          }
        : undefined,
    [db, editor, kind],
  );
  if (!editor)
    return (
      <main className="page">
        <h1>{contentLabels[kind]}编辑</h1>
        <p role="status">{message || "正在读取…"}</p>
        <Link to={contentPath(kind)}>返回列表</Link>
      </main>
    );
  const value = editor.value;
  const change = (patch: Partial<Content>) => {
    setPreview(false);
    setMessage("");
    void editor.change(patch);
  };
  return (
    <main className={"page item-form content-editor "+kind+"-editor"} id="main">
      <Link className="back-link" to={contentPath(kind)}>保留草稿并返回{contentLabels[kind]}</Link>
      <h1>
        {editor.source ? "整理为" : editor.baseRevision ? "编辑" : "新建"}
        {contentLabels[kind]}
      </h1>
      <p role="status">{editor.message}</p>
      {comparison &&
        (comparison.branches.length > 1 ||
          (comparison.current &&
            comparison.current.revision !== editor.baseRevision)) && (
          <Disclosure open>
            <summary>比较当前版本与草稿分支</summary>
            {comparison.current && (
              <ContentSnapshot item={comparison.current} />
            )}
            {comparison.branches.map((d) => (
              <section key={d.id}>
                <p>
                  草稿 · 基准 {d.baseRevision} · {d.updatedAt}
                </p>
                <ContentSnapshot item={d.payload} />
                {d.id !== editor.draftId && (
                  <Link
                    to={`${contentPath(kind, d.targetId)}/edit?draft=${d.id}`}
                  >
                    继续此草稿
                  </Link>
                )}
              </section>
            ))}
          </Disclosure>
        )}

      {"diaryDate" in value && (
        <label className="diary-date-field">
          <span>日记日期</span>
          <Input
            type="date"
            value={value.diaryDate}
            disabled={busy}
            onChange={(e) => change({ diaryDate: e.target.value })}
          />
        </label>
      )}
      <label className="content-title-input">
        <span className={kind==="diary"?"sr-only":""}>{kind === "decision"
          ? "问题"
          : kind === "diary"
            ? "标题（可选）"
            : "标题"}</span>
        <Input
          placeholder={kind==="diary"?"标题（可选）":undefined}
          value={value.title}
          disabled={busy}
          maxLength={200}
          onChange={(e) => change({ title: e.target.value })}
        />
      </label>
      <label className="prose-input">
        <span className={kind==="diary"?"sr-only":""}>{kind === "resource" ? "原文 / 正文" : "正文"}</span>
        <Textarea
          value={value.body}
          disabled={busy}
          onChange={(e) => change({ body: e.target.value })}
        />
      </label>
      {"url" in value && (
        <>
          <label>
            来源链接
            <Input
              value={value.url}
              disabled={busy}
              onChange={(e) => change({ url: e.target.value })}
            />
          </label>
          <label>
            摘录
            <Textarea
              value={value.excerpt}
              disabled={busy}
              onChange={(e) => change({ excerpt: e.target.value })}
            />
          </label>
          <label>
            摘要
            <Textarea
              value={value.summary}
              disabled={busy}
              onChange={(e) => change({ summary: e.target.value })}
            />
          </label>
          <p>链接不等于网页全文。Nook 不抓取网页内容。</p>
        </>
      )}
      {"choice" in value && (
        <>
          <label>
            当前选择
            <Input
              value={value.choice}
              disabled={busy}
              onChange={(e) => change({ choice: e.target.value })}
            />
          </label>
          <label>
            理由
            <Textarea
              value={value.reason}
              disabled={busy}
              onChange={(e) => change({ reason: e.target.value })}
            />
          </label>
          <p>发布修改会新增修订；旧选择与理由保留。</p>
        </>
      )}
      <label className="inline-field">
        标签（用逗号分隔）
        <Input
          value={tagText ?? ""}
          disabled={busy}
          onChange={(e) => {
            setTagText(e.target.value);
            void editor.tags([
              ...new Set(
                e.target.value
                  .split(/[,，]/)
                  .map((t) => t.trim())
                  .filter(Boolean),
              ),
            ]);
          }}
        />
      </label>
      <label className="image-picker" role="button" tabIndex={busy||editor.pending?-1:0} aria-disabled={busy||editor.pending} onKeyDown={e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();if(!busy&&!editor.pending)e.currentTarget.querySelector('input')?.click();}}}>
        添加图片
        <Input
          type="file"
          className="file-picker-input"
          aria-hidden="true"
          tabIndex={-1}
          accept="image/*"
          disabled={busy || editor.pending}
          onChange={(e) => {
            const file = e.target.files?.[0];
            e.target.value = "";
            if (file) {
              setBusy(true);
              void editor
                .flush()
                .then(() => prepareImage(file))
                .then((p) => editor.image(p))
                .catch((err) => setMessage(err.message))
                .finally(() => setBusy(false));
            }
          }}
        />
      </label>
      <div className="attachment-grid">
        {value.attachmentIds.map((a) => (
          <AttachmentImage
            key={a}
            id={a}
            prepared={editor.imageData(a)}
            onRemove={
              busy
                ? undefined
                : () =>
                    change({
                      attachmentIds: value.attachmentIds.filter((x) => x !== a),
                    })
            }
          />
        ))}
      </div>
      {preview && (
        <section className="notice">
          <h2>整理预览</h2>
          <p>
            新建{contentLabels[kind]}：{contentTitle(value)}
            。成功后原记录标为已整理；原文和图片保留。
          </p>
        </section>
      )}
      <p role="alert">{message}</p>
      {message.includes("新版本") && (
        <Button
          disabled={busy || editor.pending}
          onClick={() => void publish(true)}
        >
          保留原对象，另存为新{contentLabels[kind]}
        </Button>
      )}
      {editor.failure && (
        <Button
          disabled={busy || editor.pending}
          onClick={() => void editor.save()}
        >
          重试保存草稿
        </Button>
      )}
      <Button
        className="button primary"
        disabled={busy || editor.pending || editor.failure}
        onClick={() => void publish()}
      >
        {editor.source
          ? preview
            ? "确认整理"
            : "预览整理"
          : "发布" + contentLabels[kind]}
      </Button>
      <Button
        onClick={() =>
          exportText(JSON.stringify(value, null, 2), "Nook-content-draft.json")
        }
      >
        导出当前输入
      </Button>
      {editor.draftRevision > 0 && (
        <Button
          disabled={busy || editor.pending}
          onClick={() => {
            if (confirm("将草稿移入回收站？已发布内容保留。")) {
              setBusy(true);
              void editor.service
                .draftLifecycle(
                  editor.draftId,
                  editor.draftRevision,
                  "trash",
                  crypto.randomUUID(),
                )
                .then(() => {
                  done.current = true;
                  navigate(contentPath(kind));
                })
                .catch((e) => setMessage(e.message))
                .finally(() => setBusy(false));
            }
          }}
        >
          放弃这份草稿
        </Button>
      )}
    </main>
  );
}
export function ContentDetail({ kind }: { kind: ContentKind }) {
  const { db } = useService(),
    { id = "" } = useParams(),
    navigate = useNavigate();
  const [busy, setBusy] = useState(false),
    [message, setMessage] = useState("");
  usePendingNavigation(busy);
  const data = useLiveQuery(
    () =>
      db.transaction("r", db.tables, async () => ({
        current: await new ContentService(db).get(kind, id),
        branches: (
          await db.contentDrafts.where("targetId").equals(id).toArray()
        ).filter((d) => !d.deletedAt),
        visible: (await visibleContent(db, kind)).find(
          (x) => x.item.id === id && !x.conflict,
        ),
        tagNames: new Map((await db.tags.toArray()).map((t) => [t.id, t.name])),
        history: await db.revisions
          .where("[entityType+entityId]")
          .equals([kind, id])
          .toArray(),
      })),
    [db, kind, id],
  );
  async function action(fn: () => Promise<unknown>) {
    setBusy(true);
    setMessage("正在保存…");
    try {
      await fn();
      setMessage("已保存");
    } catch (e) {
      setMessage((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  if (!data) return <LoadingPage />;
  if (!data.current)
    return (
      <main className="page">
        <h1>记录不存在</h1>
        <Link to={contentPath(kind)}>返回列表</Link>
      </main>
    );
  const item = data.visible?.item ?? data.current,
    current = data.current,
    s = new ContentService(db);
  return (
    <main className={"page content-detail "+kind+"-detail"} id="main">
      <Link className="back-link" to={contentPath(kind)}>返回{contentLabels[kind]}列表</Link>
      <h1>{contentTitle(item)}</h1>
      <p>
        {contentLabels[kind]}
        {data.visible?.draft ? " · 草稿（尚未发布）" : ""}
        {current.deletedAt ? " · 回收站" : ""}
        {current.archivedAt ? " · 已归档" : ""} ·{" "}
        {"diaryDate" in item ? item.diaryDate : item.updatedAt.slice(0, 10)}
      </p>
      {!current.deletedAt && (
        <Link
          to={`${contentPath(kind, id)}/edit${data.visible?.draft ? "?draft=" + data.visible.draft.id : ""}`}
        >
          编辑{contentLabels[kind]}
        </Link>
      )}
      {!!data.branches.filter((d) => d.id !== data.visible?.draft?.id)
        .length && (
        <aside className="notice">
          <h2>待比较草稿分支</h2>
          {data.branches
            .filter((d) => d.id !== data.visible?.draft?.id)
            .map((d) => (
              <Link
                key={d.id}
                className="text-link"
                to={`${contentPath(kind, id)}/edit?draft=${d.id}`}
              >
                {contentTitle(d.payload)} · 草稿 · 基准 {d.baseRevision}
              </Link>
            ))}
        </aside>
      )}
      <article className="capture-body">{item.body}</article>
      {"url" in item && (
        <>
          <p className="small-note">
            {!item.body.trim()
              ? item.url
                ? "仅保存链接；未保存网页全文"
                : "未保存原文；仅保存摘录、摘要或图片"
              : "已保存用户输入的正文；未抓取网页全文"}
          </p>
          {item.url && safeLink(item.url) && (
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              来源链接：{item.url}
            </a>
          )}
          {item.url && !safeLink(item.url) && (
            <p>草稿链接尚未有效，不能打开。</p>
          )}
          {item.excerpt&&<><h2>摘录</h2><p className="capture-body">{item.excerpt}</p></>}
          {item.summary&&<><h2>摘要</h2><p className="capture-body">{item.summary}</p></>}
        </>
      )}
      {"choice" in item && (
        <>
          <h2>当前选择</h2>
          <p>{item.choice}</p>
          <h2>理由</h2>
          <p className="capture-body">{item.reason}</p>
        </>
      )}
      <div className="attachment-grid">
        {item.attachmentIds.map((a) => (
          <AttachmentImage key={a} id={a} />
        ))}
      </div>
      <Disclosure className="content-metadata"><summary>日期与标签</summary>      <p>
        实际创建：{current.createdAt} · 标签：
        {item.tagIds
          .map((id) => data.tagNames.get(id) ?? "标签缺失")
          .join("、") || "无"}
      </p>
      </Disclosure>
      <div className="detail-actions">
        {!current.deletedAt && (
          <Button
            disabled={busy}
            onClick={() =>
              void action(() =>
                s.lifecycle(
                  kind,
                  id,
                  current.revision,
                  current.archivedAt ? "unarchive" : "archive",
                  crypto.randomUUID(),
                ),
              )
            }
          >
            {current.archivedAt ? "撤销归档" : "归档"}
          </Button>
        )}
        <Button
          disabled={busy}
          onClick={() =>
            void action(() =>
              s.lifecycle(
                kind,
                id,
                current.revision,
                current.deletedAt ? "restore" : "trash",
                crypto.randomUUID(),
              ),
            )
          }
        >
          {current.deletedAt ? "从回收站恢复" : "移入回收站"}
        </Button>
        {current.deletedAt && (
          <Button
            disabled={busy}
            onClick={() => {
              if (confirm("永久删除内容及历史？"))
                void action(async () => {
                  await s.lifecycle(
                    kind,
                    id,
                    current.revision,
                    "purge",
                    crypto.randomUUID(),
                  );
                  navigate("/trash");
                });
            }}
          >
            永久删除
          </Button>
        )}
      </div>
      <p role="status">{message}</p>
      <Disclosure>
        <summary>查看当时版本 · {data.history.length} 个版本</summary>
        {data.history
          .sort((a, b) => b.revision - a.revision)
          .map((r) => (
            <section className="history-row" key={r.id}>
              <h2>版本 {r.revision}</h2>
              <p>
                {r.recordedAt} · {r.reason}
              </p>
              <ContentSnapshot item={r.snapshot as Content} />
              {!current.deletedAt && (
                <Button
                  disabled={busy}
                  onClick={() => {
                    if (confirm("以此历史新增修订？当前版本和草稿均保留。"))
                      void action(() =>
                        s.restoreHistory(
                          kind,
                          id,
                          current.revision,
                          r.revision,
                          crypto.randomUUID(),
                        ),
                      );
                  }}
                >
                  以此版本新增修订
                </Button>
              )}
            </section>
          ))}
      </Disclosure>
    </main>
  );
}
export function DiaryPrivacy() {
  const { db } = useService(),
    [message, setMessage] = useState(""),
    [busy, setBusy] = useState(false),
    [local, setLocal] = useState<Record<string, string>>({});
  usePendingNavigation(busy);
  const values = useLiveQuery(() => db.settings.toArray(), [db]);
  useEffect(() => {
    if (!values || busy) return;
    setLocal((old) => {
      const next = { ...old };
      let changed = false;
      for (const [key, value] of Object.entries(old))
        if (values.find((row) => row.key === key)?.value === value) {
          delete next[key];
          changed = true;
        }
      return changed ? next : old;
    });
  }, [values, busy]);
  async function change(key: "diarySearch" | "diarySummary", checked: boolean) {
    const value = checked
      ? key === "diarySearch"
        ? "excluded"
        : "hidden"
      : "visible";
    setLocal((old) => ({ ...old, [key]: value }));
    setBusy(true);
    setMessage("正在保存隐私设置…");
    try {
      await db.transaction("rw", db.meta, db.settings, async () => {
        await assertWritable(db);
        await db.settings.put({ key, value });
        await markSearchDirty(db);
      });
      setMessage("隐私设置已保存");
    } catch (e) {
      setLocal((old) => {
        const next = { ...old };
        delete next[key];
        return next;
      });
      setMessage((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section>
      <h2>日记隐私</h2>
      {(["diarySearch", "diarySummary"] as const).map((key) => (
        <label key={key}>
          <Toggle
            disabled={busy || !values}
            checked={
              (local[key] ?? values?.find((x) => x.key === key)?.value) ===
              (key === "diarySearch" ? "excluded" : "hidden")
            }
            onChange={(e) => void change(key, e.target.checked)}
          />
          {key === "diarySearch"
            ? "从全局搜索排除日记（含草稿）"
            : "隐藏日记列表与搜索摘要（含标题）"}
        </label>
      ))}
      <p role="status">{message}</p>
    </section>
  );
}
